{
  "*Taxes will be calculated when the invoice is created.": "*Taxes will be calculated when the invoice is created.",
  "Canceled": "Canceled",
  "Clear": "Clear",
  "Contact Support": "Contact Support",
  "Device Orders": "Device Orders",
  "Filter": "Filter",
  "Locations": "Locations",
  "No Image Available": "No Image Available",
  "Order Date": "Order Date",
  "Order Details": "Order Details",
  "Order Number": "Order Number",
  "Order Placed": "Order Placed",
  "Order Placed on {{date}}": "Order Placed on {{date}}",
  "Order Total": "Order Total",
  "Partially Shipped": "Partially Shipped",
  "Phone Model Name": "Phone Model Name",
  "Processing": "Processing",
  "Qty:": "Qty:",
  "Refresh": "Refresh",
  "Search": "Search",
  "Select All": "Select All",
  "Shipped": "Shipped",
  "Status": "Status",
  "Taxes": "Taxes",
  "There are currently no locations accessible for viewing {{pageTitle}}.": "There are currently no locations accessible for viewing {{pageTitle}}.",
  "Total": "Total",
  "Tracking #'s:": "Tracking #'s:",
  "Unknown": "Unknown",
  "View and manage device orders made through Weave.": "View and manage device orders made through Weave.",
  "View and manage device orders made through Weave. Select your preferred location to continue:": "View and manage device orders made through Weave. Select your preferred location to continue:",
  "{{carrier}} Tracking:": "{{carrier}} Tracking:"
}
